import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-helpcenter-faqs',
  templateUrl: './helpcenter-faqs.component.html',
  styleUrls: ['./helpcenter-faqs.component.css'],
  standalone: false,
})
export class HelpcenterFaqsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }


}
